import { trigger, state, animate, style, transition } from '@angular/animations';

export function correctHeight() {
  const pageWrapper = document.getElementById('page-wrapper');
  const nav = document.querySelector('nav.navbar-default');
  if (pageWrapper && nav) {
    const navbarHeigh = nav.clientHeight;
    const wrapperHeigh = pageWrapper.clientHeight;

    if (navbarHeigh > wrapperHeigh) {
      pageWrapper.style.minHeight = navbarHeigh + 'px';
    }

    if (navbarHeigh < wrapperHeigh) {
      if (navbarHeigh < document.body.clientHeight) {
        pageWrapper.style.minHeight = document.body.clientHeight - 25 + 'px';
      } else {
        pageWrapper.style.minHeight = navbarHeigh + 'px';
      }
    }

    if (document.body.classList.contains('fixed-nav')) {
      if (navbarHeigh > wrapperHeigh) {
        pageWrapper.style.minHeight = navbarHeigh + 'px';
      } else {
        pageWrapper.style.minHeight = document.body.clientHeight - 25 + 'px';
      }
    }
  }
}

export function detectBody() {
  if (document.body.clientWidth < 769) {
    document.body.classList.add('body-small');
  } else {
    document.body.classList.remove('body-small');
  }
}

function unfade(element) {
  let op = 0.1;
  element.style.opacity = op;
  element.style.display = 'block';
  const timer = setInterval(() => {
    if (op >= 1) {
      clearInterval(timer);
    }
    element.style.opacity = op;
    element.style.filter = 'alpha(opacity=' + op * 1000 + ')';
    op += op * 0.1;
  }, 10);
}


export function smoothlyMenu() {
  const sideMenu = document.getElementById('side-menu');
  if (!document.body.classList.contains('mini-navbar') || document.body.classList.contains('body-small')) {
    sideMenu.style.display = 'none';
    setTimeout(() => {
      unfade(sideMenu);
    }, 200);
  } else if (document.body.classList.contains('fixed-sidebar')) {
    sideMenu.style.display = 'none';
    setTimeout(() => {
      unfade(sideMenu);
    }, 100);
  } else {

  }
}

export function tableHeadFixer(param) {

  document.getElementById('parent').style.overflow = 'auto';

  document.getElementById('parent').querySelectorAll('th').forEach(el => {
    el.style.boxShadow = 'rgb(221, 221, 221) 0px -2px 0px inset';
  });

  document.getElementById('parent').addEventListener('scroll', function () {
    const translate = 'translate(0,' + this.scrollTop + 'px)';
    document.getElementById(param).querySelectorAll('th').forEach(el => {
      el.style.transform = translate;
      el.style.position = 'relative';
      el.style.zIndex = '99';
    });
  });
}


export function tableHeadFixerWithUniqueParent(param, parentId) {
  if (parentId) {
    document.getElementById(parentId).style.overflow = 'auto';

    document.getElementById(parentId).querySelectorAll('th').forEach(el => {
      el.style.boxShadow = 'rgb(221, 221, 221) 0px -2px 0px inset';
    });

    document.getElementById(parentId).addEventListener('scroll', function () {
      const translate = 'translate(0,' + (this.scrollTop - 1) + 'px)';
      document.getElementById(param).querySelectorAll('th').forEach(el => {
        el.style.transform = translate;
        el.style.position = 'relative';
        el.style.zIndex = '99';
      });
    });
  }
}



